"use client";

import * as React from "react";
import { Line, LineChart, ResponsiveContainer, Tooltip } from "recharts";
import { chartYAxis } from "@/components/chart-axes";
import {
  lineSeriesProps,
  previewChartMargin,
  prepareChartDataForScale,
  tooltipConfig,
  resolveSeriesColor,
  seriesLineStyle,
} from "@/utils";

export type PreviewLine = {
  dataKey: string;
  name: string;
  stroke: string;
};

type PreviewLineChartProps = {
  data: Record<string, unknown>[];
  lines: PreviewLine[];
};

export function PreviewLineChart({ data, lines }: PreviewLineChartProps) {
  const chartScaleData = React.useMemo(
    () => prepareChartDataForScale(data, lines, true),
    [data, lines],
  );

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={chartScaleData.data} margin={previewChartMargin}>
        {chartYAxis({
          label: "",
          logScale: true,
          hideLabel: true,
          hide: true,
          width: 0,
          domain: chartScaleData.yDomain,
        })}
        <Tooltip
          {...tooltipConfig({
            cursor: { stroke: "rgba(255,255,255,0.08)", strokeWidth: 1 },
          })}
        />
        {lines.map((props, index) => {
          const stroke = resolveSeriesColor(props.dataKey, props.name, index);
          return (
            <Line
              key={props.dataKey}
              {...lineSeriesProps}
              {...props}
              stroke={stroke}
              style={seriesLineStyle(stroke)}
            />
          );
        })}
      </LineChart>
    </ResponsiveContainer>
  );
}
